import { navigator, matchMedia } from 'window';

import _ from 'lodash';

const { userAgent, platform } = navigator;

export const browserTypes = {
	opera: {
		name: 'opera',
		test: check(/Opera|OPR/),
		relevantVersions: {},
	},
	/** 
	 * TODO: При входе с Chrome детектор показывает Safari
	*/
	chrome: {
		name: 'chrome',
		test: check(/Chrome/),
		relevantVersions: {},
	},
	safari: {
		name: 'safari',
		test: check(/Safari/),
		relevantVersions: {},
	},
	firefox: {
		name: 'firefox',
		test: check(/Firefox/),
		relevantVersions: {},
	},
	ie: {
		name: 'ie',
		test: check(/Trident/),
		relevantVersions: {
			'8': {
				name: '8',
				test: check(/MSIE 8/),
			},
			'9': {
				name: '9',
				test: check(/MSIE 9/),
			},
			'10': {
				name: '10',
				test: check(/MSIE 10/),
			},
			'11': {
				name: '11',
				test: check(/rv:11/),
			},
		},
	},
	android: {
		name: 'android',
		test: check(/Android/i),
		relevantVersions: {},
	},
	edge: {
		name: 'edge',
		test: check(/Edge/),
		relevantVersions: {},
	},
};

function check (regex) {
	return () => regex.test(userAgent);
}

function getType () {

	const result = {};

	_.each(browserTypes, browser => {
		if (browser.test()) {
			_.extend(result, {
				name: browser.name,
				version: _.find(browser.relevantVersions, version => version.test()),
			});
		}
	});

	return result;
}

function isIOS () {
	return [
		'iPad Simulator',
		'iPhone Simulator',
		'iPod Simulator',
		'iPad',
		'iPhone',
		'iPod',
		'iOS',
	].includes(platform)
		// iPad on iOS 13 detection
		|| (platform === 'MacIntel' && navigator.maxTouchPoints > 0);
}

function isStandalonePwa () {
	return navigator.standalone || matchMedia('(display-mode: standalone)').matches;
}

export default {
	isIe: () => browserTypes.ie.test(),
	
	isIe8: () => getType().name === browserTypes.ie.name
		&& getType().version === browserTypes.ie.relevantVersions['8'],

	isIe9: () => getType().name === browserTypes.ie.name
		&& getType().version === browserTypes.ie.relevantVersions['9'],

	isIe10: () => getType().name === browserTypes.ie.name
		&& getType().version === browserTypes.ie.relevantVersions['10'],

	isIe11: () => getType().name === browserTypes.ie.name
		&& getType().version === browserTypes.ie.relevantVersions['11'],

	isEdge: () => getType().name === browserTypes.edge.name,
	isOpera: () => getType().name === browserTypes.opera.name,
	isChrome: () => getType().name === browserTypes.chrome.name,
	isSafari: () => getType().name === browserTypes.safari.name,
	isFirefox: () => getType().name === browserTypes.firefox.name,

	isAndroid: () => getType().name === browserTypes.android.name,
	isIOS: () => isIOS(),
	isStandalonePwa: () => isStandalonePwa(),

	getType,
};